import API from "../API";
import { actionPending, actionSuccess, actionError } from '../index';
import { toast } from 'react-toastify';
import { toastSuccess } from "../../components/toast/Toast";

export const MEMBER_FORGOT_PASSWORD_PENDING = 'MEMBER_FORGOT_PASSWORD_PENDING'
export const MEMBER_FORGOT_PASSWORD_SUCCESS = 'MEMBER_FORGOT_PASSWORD_SUCCESS'
export const MEMBER_FORGOT_PASSWORD_ERROR = 'MEMBER_FORGOT_PASSWORD_ERROR'

const MEMBER_FORGOT_PASSWORD_URL = 'auth/forgot_password';

export function memberForgotPassword(param = {}, resolve, reject, callback) {
    return dispatch => {
        dispatch(actionPending(MEMBER_FORGOT_PASSWORD_PENDING));
        API.post(MEMBER_FORGOT_PASSWORD_URL, param)
            .then(res => {
                if (res.error) {
                    throw (res.error);
                }
                dispatch(actionSuccess(MEMBER_FORGOT_PASSWORD_SUCCESS, res.data));
                if (resolve) {
                    resolve({
                        data: res.data.data,
                    })
                }
                // toastSuccess("Silahkan cek email anda");
                if (callback) {
                    callback();
                }
            })
            .catch(error => {
                dispatch(actionError(MEMBER_FORGOT_PASSWORD_ERROR, error.response.data.message));
                if (error.response && error.response.status === 500) {
                    if (resolve){
                        resolve({
                            data: error.response.data.message,
                        })
                    }
                   
                    // toast.error(error.response.data.message, {
                    //     position: "top-right",
                    //     autoClose: 3000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true
                    // });

                } else {
                    toast.error(error.toString(), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                }
                if (callback) {
                    callback();
                }
            })
    };
}